
// Imports
import { Injectable } from '@angular/core';

import { XhrService } from '../../service/xhr.service';

// Import RxJs required methods
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { PostBody } from '../../shared/postBody';

import { User } from '../../module/user/shared/user';

@Injectable()
export class ProfileService {

    // Resolve HTTP using the constructor
    constructor(private xhrService: XhrService) {

    }
    
    get() {
        return this.xhrService.get('profile/read/');
    }
   
    update(user:User) {
        let postBody:PostBody={method:"profile.update"};
        postBody["user"] = user;
        return this.xhrService.post('profile/update/',postBody);
    }

    


}



// WEBPACK FOOTER //
// ./src/app/admin/profile/profile.service.ts